import React, { useEffect } from 'react';
const { useState } = React;

export const useAudio = (url: string) => {
    const [audio, setAudio] = useState(new Audio(url));
    const [playing, setPlaying] = useState(false);
    const [ended, setEnded] = useState(false);
    const toggle = () => {
        setPlaying(prev => !prev);
    }

    const changeTrack = (url: string) => {
        setEnded(false);
        audio.pause();
        setAudio(new Audio(url));
    }

    const changeVolume = (vol: number) => {
        audio.volume = vol;
    }

    useEffect(() => {
        if (!/preview/.test(audio.src)) return;
        audio.addEventListener("ended", () => {
            setPlaying(false);
            setEnded(true);
        })
        setPlaying(true);
    }, [audio])

    useEffect(() => {
        playing ? audio.play() : audio.pause();
    }, [playing]);

    return {
        playing,
        toggle,
        changeTrack,
        changeVolume,
        ended,
        trackURL: audio.src
    };
}